// extracted by mini-css-extract-plugin
export default {"headingWrapper":"zDLonT0q2GjVE17wSGq0","proofSection":"iYAz1bmsh4n0zRC8GuzM","subtitleWrapper":"KtwAgD6ciS3noQ1rLtxL","toggle":"gU39hnA6r4O1fjBhKg30"};